import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["id", "name", "checked", "value", "error", "defaultValue", "children", "onChange"];
var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB-JOB1/src/components/Radio/RadioInput.js",
  _this = this;
import React from 'react';
import styled, { css } from 'styled-components';
import { withOpacity } from '../../helpers';
import { noop } from '@lux/helpers';
import { withTheme } from '../../core/ThemeProvider';
var RadioInput = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var id = props.id,
    name = props.name,
    checked = props.checked,
    value = props.value,
    error = props.error,
    defaultValue = props.defaultValue,
    children = props.children,
    onChange = props.onChange,
    rest = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement(Label, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 22,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(RadioButton, {
    error: Boolean(error),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 23,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement("input", _extends({}, rest, {
    id: id,
    type: "radio",
    name: name,
    checked: checked,
    value: value,
    defaultValue: defaultValue,
    onChange: onChange,
    ref: ref,
    "data-testid": rest['data-testid'],
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 24,
      columnNumber: 9
    }
  })), /*#__PURE__*/React.createElement(RadioButtonEffect, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 37,
      columnNumber: 9
    }
  })), /*#__PURE__*/React.createElement(LabelText, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 39,
      columnNumber: 7
    }
  }, children));
});
RadioInput.displayName = 'RadioInput';
RadioInput.defaultProps = {
  value: 0,
  onChange: noop
};
/* stylelint-disable no-descending-specificity */

var LabelText = withTheme(styled.span.withConfig({
  displayName: "RadioInput__LabelText",
  componentId: "sc-1vieb2h-0"
})(["", ""], function (p) {
  return css(["color:", ";font-family:", ";font-size:", ";width:calc(100% - 50px);overflow:hidden;text-overflow:ellipsis;line-height:1.5;"], p.coreTheme.cl_ter_base, p.coreTheme.ff_sec_thin, p.coreTheme.fs_xl);
}));
var RadioButtonEffect = styled(withTheme(styled.div.withConfig({
  displayName: "RadioInput__RadioButtonEffect",
  componentId: "sc-1vieb2h-2"
})(["display:inline-block;position:absolute;box-sizing:border-box;transition:all 0.1s ease-in;", ""], function (p) {
  return css(["top:", "px;left:", "px;height:", "px;width:", "px;border-radius:", "px;border:", "px solid transparent;"], p.coreTheme.space_3, p.coreTheme.space_3, p.coreTheme.space_8, p.coreTheme.space_8, p.coreTheme.space_5, p.coreTheme.space_2);
}))).withConfig({
  displayName: "RadioInput__RadioButtonEffect",
  componentId: "sc-1vieb2h-1"
})({});
var RadioButton = styled(withTheme(styled.div.withConfig({
  displayName: "RadioInput__RadioButton",
  componentId: "sc-1vieb2h-4"
})(["display:inline-block;height:56px;width:56px;min-width:56px;border-radius:50%;overflow:hidden;position:relative;transition:all 0.1s ease-in;background-color:transparent;padding:12px;box-sizing:border-box;", ";"], function (p) {
  return css(["margin-right:", "px;margin-left:-", "px;input[type='radio']{transition:all 0.1s ease-in;display:inline-block;height:32px;width:32px;border-radius:18px;margin:0;appearance:none;background-color:", ";border:1px solid ", ";&:focus{outline:none;}&:checked{border-color:", ";}&:checked + ", "{border-color:", ";}&::-ms-check{color:transparent;}}&:hover{background-color:", ";}"], p.coreTheme.space_1, p.coreTheme.space_3, p.coreTheme.cl_white, p.error ? p.coreTheme.cl_pri_d3 : p.coreTheme.cl_ter_l4, p.coreTheme.cl_ter_l5, /* sc-selector */
  RadioButtonEffect, p.coreTheme.cl_sec_d1, withOpacity(p.coreTheme.cl_sec_l1, 0.8));
}))).withConfig({
  displayName: "RadioInput__RadioButton",
  componentId: "sc-1vieb2h-3"
})({});
var Label = withTheme(styled.label.withConfig({
  displayName: "RadioInput__Label",
  componentId: "sc-1vieb2h-5"
})(["display:flex;align-items:center;margin:12px 0;cursor:pointer;:active{", "{opacity:0.5;}}:hover{", "{background-color:", ";}}"], /* sc-selector */
RadioButtonEffect, /* sc-selector */
RadioButton, function (p) {
  return withOpacity(p.coreTheme.cl_sec_l1, 0.8);
}));
export default RadioInput;